import React from 'react';
import PropTypes from 'prop-types';
import { ApIcon, ApButtonIcon, colors } from '@alixpartners/ui-components';
import { Row, Wrapper, Label, Helper } from './FileList.styles';
import { getUploadedTime } from './utils';

export const FileList = ({ data, onClick, onDelete }) => {
	if (data.length === 0) {
		return (
			<Wrapper>
				<Row>
					<ApIcon iconName="cloud_upload" iconColor={colors.grey8} />
					<Label>No data uploaded</Label>
				</Row>
			</Wrapper>
		);
	}

	return (
		<Wrapper>
			{data.map(({ fileName, date, userName }) => (
				<Row key={fileName}>
					<ApIcon iconName="check" iconColor={colors.grey8} />
					<Label onClick={onClick}>{fileName}</Label>
					<Helper>
						Published by {userName} {getUploadedTime(date)}
					</Helper>
					{onDelete && <ApButtonIcon iconName="delete_outline" />}
				</Row>
			))}
		</Wrapper>
	);
};

FileList.propTypes = {
	data: PropTypes.arrayOf(PropTypes.object),
	onClick: PropTypes.func,
	onDelete: PropTypes.func,
};

FileList.defaultProps = {
	data: [],
};

export default FileList;
